const COMMON_SYMBOL_ALIASES = {
    台積電: '2330.TW',
    台積電ADR: 'TSM',
    聯發科: '2454.TW',
    鴻海: '2317.TW',
    廣達: '2382.TW',
    緯創: '3231.TW',
    緯穎: '6669.TW',
    台達電: '2308.TW',
    台灣50: '0050.TW',
    元大台灣50: '0050.TW',
    高股息: '0056.TW',
    元大高股息: '0056.TW',
    輝達: 'NVDA',
    NVIDIA: 'NVDA',
    微軟: 'MSFT',
    MICROSOFT: 'MSFT',
    特斯拉: 'TSLA',
    TESLA: 'TSLA',
    蘋果: 'AAPL',
    APPLE: 'AAPL',
    超微: 'AMD',
    英特爾: 'INTC',
    谷歌: 'GOOGL',
    GOOGLE: 'GOOGL',
    亞馬遜: 'AMZN',
    AMAZON: 'AMZN',
};
const TAIWAN_CODE_RE = /^\d{4,6}[A-Z]?$/;
function compactInput(input) {
    return input.normalize('NFKC').trim().replace(/\s+/g, '').toUpperCase();
}
/**
 * Normalize user-facing stock input into the Yahoo Finance symbol used internally.
 * Examples: 2330 → 2330.TW, TWSE:2330 → 2330.TW, OTC:6488 → 6488.TWO, 輝達 → NVDA.
 */
export function normalizeSymbolInput(input) {
    let value = compactInput(input).replace(/^\$/, '');
    if (!value)
        return undefined;
    const alias = COMMON_SYMBOL_ALIASES[value];
    if (alias)
        return alias;
    const twsePrefixed = value.match(/^(TWSE|TSE|TPE|TW):(\d{4,6}[A-Z]?)$/);
    if (twsePrefixed)
        return `${twsePrefixed[2]}.TW`;
    const otcPrefixed = value.match(/^(TWO|OTC):(\d{4,6}[A-Z]?)$/);
    if (otcPrefixed)
        return `${otcPrefixed[2]}.TWO`;
    const usPrefixed = value.match(/^(NASDAQ|NYSE|AMEX|ARCA|BATS):([A-Z0-9.-]+)$/);
    if (usPrefixed)
        return usPrefixed[2];
    const twSuffix = value.match(/^(\d{4,6}[A-Z]?)\.(TW|TWO|TWSE|TSE|TPE|OTC)$/);
    if (twSuffix)
        return `${twSuffix[1]}.${twSuffix[2] === 'TWO' || twSuffix[2] === 'OTC' ? 'TWO' : 'TW'}`;
    if (TAIWAN_CODE_RE.test(value))
        return `${value}.TW`;
    return value;
}
/** Parse comma/space separated symbols and remove duplicates while preserving order. */
export function parseSymbolInputs(input) {
    const seen = new Set();
    const symbols = [];
    for (const token of input.split(/[\s,，、;；]+/)) {
        const symbol = normalizeSymbolInput(token);
        if (!symbol || seen.has(symbol))
            continue;
        seen.add(symbol);
        symbols.push(symbol);
    }
    return symbols;
}
export function isTaiwanSymbol(symbol) {
    const normalized = normalizeSymbolInput(symbol) ?? compactInput(symbol);
    return /\.(TW|TWO)$/i.test(normalized);
}
export function inferMarketFromSymbol(symbol, fallback = 'US') {
    if (!symbol.trim())
        return fallback;
    return isTaiwanSymbol(symbol) ? 'TW' : fallback;
}
//# sourceMappingURL=symbols.js.map